import React from "react";
import styles from "./styles.module.scss";

const SkeletonLoader = ({
  animation = "pulse",
  children,
  className,
  component: Component = "span",
  height,
  style,
  variant = "text",
  width,
  ...other
}) => {
  const hasChildren = Boolean(children);

  const skeletonClasses = [
    styles.root,
    styles[variant],
    animation !== false && styles[`animation-${animation}`],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const skeletonStyle = {
    width,
    height,
    ...(hasChildren && { display: "none" }),
    ...style,
  };

  return (
    <Component className={skeletonClasses} style={skeletonStyle} {...other}>
      {children}
    </Component>
  );
};

SkeletonLoader.displayName = "Skeleton";

export default SkeletonLoader;
